import { FeedDataDto, FeedItemDto, FeedType } from "generated/CoreApi_v1";
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { JSX, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router";
import { FeedManager } from "views/knowledge/feed/components";
import { FeedBoxPanels } from "views/knowledge/feed/components/FeedBoxPanels";
import { FeedContainer, RightPanelBreakpoints } from "views/knowledge/feed/components/FeedContainer";
import { FeedManagerHandle } from "views/knowledge/feed/components/FeedManager";
import { OutsideRightPanel } from "views/knowledge/publication/pages/components/OutsideRightPanel";
import { IFeedQuestionFilterOptions } from "views/knowledge/publication/pages/Question/FeedQuestionFilter";

interface IProps {
    publication: FeedItemDto;
    feedType: FeedType;
    cardHeader?: JSX.Element;
    rightPanel?: React.ReactElement[];
    filter: IFeedQuestionFilterOptions;
    count?: number | null;
    answerId?: string;
    marginRightPanel?: number;
    openRightPanel?: boolean;
    rightPanelBreakpoint: RightPanelBreakpoints;
    onCloseRightPanel?: () => void;
    onGoBackStart?: () => void;
    onRefreshData(data?: FeedDataDto, resetFilter?: boolean): void;
}

const FeedQuestion: React.FC<IProps> = (props) => {

    const {
        publication, feedType, count, cardHeader, rightPanel, filter, answerId, marginRightPanel,
        openRightPanel, rightPanelBreakpoint,
        onGoBackStart, onCloseRightPanel, onRefreshData
    } = props;

    const api = useCoreApi();
    const location = useLocation();
    const navigate = useNavigate();

    const [prevPub, setPrevPub] = useState<string | null>(location.state?.publicationId ?? null);

    const feedRef = useRef<FeedManagerHandle>(undefined!);

    ///
    const onGetData = async (startIndex: number, endIndex: number) => {
        var result = await api.v1.knowledgeFeed.getFeedQuestion({
            questionPublicationId: publication.publicationId,
            startPublicationId: location.state?.publicationId ?? null,
            startIndex,
            answerId: answerId ?? null,
            endIndex,
            searchText: filter.searchText ?? null,
            orderBy: filter.orderBy,
        });
        if (startIndex == 0) onRefreshData(result.data);
        return result.data.items;
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////
    /// EFFECTS
    ////////////////////////////////////////////////////////////////////////////////////////////////

    ///
    useEffect(() => {
        if (count === null) {
            navigate("", { replace: true, state: { filter } });
        }
    }, [count]);

    ///
    useEffect(() => {
        if (prevPub !== location.state?.publicationId) {
            setPrevPub(null);
        }
        feedRef.current?.reset();
    }, [location.state]);

    ////////////////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////////////////////

    const Feed = <FeedManager
        feedType={feedType}
        onGetData={onGetData}
        otherInfo={publication?.publicationId}
        ref={feedRef}
        previousPublicationId={prevPub}
        onGobackTop={onGoBackStart}
    />;

    return (
        <>
            <FeedContainer
                feed={Feed}
                header={cardHeader}
                moreInfo={<FeedBoxPanels>{rightPanel}</FeedBoxPanels>}
                marginRightPanel={marginRightPanel}
                rightPanelBreakpoint={rightPanelBreakpoint}
            />

            {
                openRightPanel &&
                <OutsideRightPanel
                    onClose={onCloseRightPanel != undefined ? onCloseRightPanel : () => { }}
                    content={<>{rightPanel}</>}
                />
            }
        </>
    );
};

function questionPropsAreEqual(prevProps: IProps, nextProps: IProps) {
    return prevProps.publication == nextProps.publication &&
        prevProps.filter == nextProps.filter &&
        prevProps.openRightPanel == nextProps.openRightPanel &&
        prevProps.count == nextProps.count;
}

export const FeedQuestionBox = React.memo(FeedQuestion, questionPropsAreEqual);
